import { render, staticRenderFns } from "./CustomTitle.vue?vue&type=template&id=1b2da2db&scoped=true"
import script from "./CustomTitle.vue?vue&type=script&lang=js"
export * from "./CustomTitle.vue?vue&type=script&lang=js"
import style0 from "./CustomTitle.vue?vue&type=style&index=0&id=1b2da2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2da2db",
  null
  
)

export default component.exports